export default {
  bind (el, {value}) {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        // 到达可视区域
        value()
      }
    }, {
      root: null,
      threshold: 1.0
    })
    observer.observe(el)
    let observerElement = document.createElement('div')
    observerElement.style.height = '1px'
    observerElement.style.width = '100px'
    // 追加到最前面
    el.insertAdjacentElement('afterbegin', observerElement)
    observer.observe(observerElement)
    // this.$nextTick(() => {
    // })
  }
}



// WEBPACK FOOTER //
// ./src/directive/pulldown.js